<template>
  <van-action-sheet
    class="cost-entry-box"
    :closeable="false"
    :close-on-click-overlay="false"
    v-model="show"
    :title="data.title"
  >
    <div class="form-box">
      <van-form
        ref="form"
        validate-first
        :show-error-message="false"
      >
        <div class="form-item">
          <van-row
            class="form-item-box"
            gutter="36"
          >
            <van-col span="12">
              <div class="form-label">赶赴现场过境费</div>
              <div class="form-tips">从出发到客户地点</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost1"
                    class="textarea-box"
                    v-model="dataForm.cost1"
                    placeholder="0.00"
                    :rules="rules.cost1"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div
          class="form-item"
          v-if="data.showAll"
        >
          <van-row
            class="form-item-box"
            gutter="36"
          >
            <van-col span="12">
              <div class="form-label">拖车过境费</div>
              <div class="form-tips">从拖上车到修理厂卸车</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost2"
                    class="textarea-box"
                    v-model="dataForm.cost2"
                    placeholder="0.00"
                    :rules="rules.cost2"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div class="form-item">
          <van-row
            class="form-item-box"
            gutter="36"
          >
            <van-col span="12">
              <div class="form-label">等候费</div>
              <div class="form-tips">从到达客户地点开始计算</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost3"
                    class="textarea-box"
                    v-model="dataForm.cost3"
                    placeholder="0.00"
                    :rules="rules.cost3"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div
          class="form-item"
          v-if="data.showAll"
        >
          <van-row
            class="form-item-box"
            gutter="36"
            type="flex"
            align="center"
          >
            <van-col span="12">
              <div class="form-label">地库牵引</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost4"
                    class="textarea-box"
                    v-model="dataForm.cost4"
                    placeholder="0.00"
                    :rules="rules.cost4"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div
          class="form-item"
          v-if="data.showAll"
        >
          <van-row
            class="form-item-box"
            gutter="36"
            type="flex"
            align="center"
          >
            <van-col span="6">
              <div class="form-label">辅助轮</div>
            </van-col>
            <van-col span="8">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="num"
                    class="textarea-box"
                    v-model="dataForm.num"
                    placeholder="0"
                    :rules="rules.num"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">个</div>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="10">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="4">
                  <div class="form-label">共</div>
                </van-col>
                <van-col span="16">
                  <van-field
                    name="cost5"
                    class="textarea-box"
                    v-model="dataForm.cost5"
                    placeholder="0.00"
                    :rules="rules.cost5"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div class="form-item">
          <van-row
            class="form-item-box"
            gutter="36"
            type="flex"
            align="center"
          >
            <van-col span="12">
              <div class="form-label">收取客户现金</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost6"
                    class="textarea-box"
                    v-model="dataForm.cost6"
                    placeholder="0.00"
                    :rules="rules.cost6"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div class="form-item">
          <van-row
            class="form-item-box"
            gutter="36"
            type="flex"
            align="center"
          >
            <van-col span="12">
              <div class="form-label">其他费用</div>
            </van-col>
            <van-col span="12">
              <van-row
                gutter="10"
                type="flex"
                align="center"
              >
                <van-col span="20">
                  <van-field
                    name="cost7"
                    class="textarea-box"
                    v-model="dataForm.cost7"
                    placeholder="0.00"
                    :rules="rules.cost7"
                  />
                </van-col>
                <van-col span="4">
                  <div class="form-label">元</div>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div class="form-item">
          <van-row
            class="form-item-box"
            gutter="36"
          >
            <van-col span="24">
              <van-field
                name="cost8"
                class="textarea-box"
                v-model="dataForm.cost8"
                rows="2"
                type="textarea"
                placeholder="其他费用说明"
                maxlength="500"
                :rules="rules.cost8"
              />
            </van-col>
          </van-row>
        </div>
      </van-form>
    </div>
    <div class="btn-box">
      <van-row gutter="17">
        <van-col span="12">
          <van-button
            type="default"
            block
            plain
            @click="cancel"
          >取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="info"
            block
            @click="confirm"
          >确认</van-button>
        </van-col>
      </van-row>
    </div>
  </van-action-sheet>
</template>

<script>
import { Toast } from 'vant';
import {
  queryOrderFeeDetail,
  saveOrderFeeDetail
} from '@/common/apiPaic.js';
const initDataForm = () => {
  return {
    cost1: '',
    cost2: '',
    cost3: '',
    cost4: '',
    cost5: '',
    cost6: '',
    cost7: '',
    cost8: '',
    num: ''
  };
};
export default {
  name: 'OrderCostEntryBox',
  data() {
    return {
      dataForm: initDataForm(),
      show: false,
      data: {
        title: '提示',
        extraParam: null,
        showAll: true,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      },
      keyList: [
        '赶赴现场过境费',
        '拖车过境费',
        '等候费',
        '地库牵引',
        '辅助轮',
        '收取客户现金',
        '其他费用',
        '其他费用费用说明'
      ]
    };
  },
  computed: {
    rules() {
      const validator = (value) => {
        const pattern = /^(0|([1-9]\d*))(\.\d{1,2})?$/g;
        if (!value) {
          return true;
        } else if (pattern.test(value) && value >= 0 && value <= 99999999.99) {
          return true;
        } else {
          return false;
        }
      };
      const rule = [
        { validator, message: '请输入正确格式的数值，最大99999999.99', trigger: 'onBlur' }
      ];
      const obj = {};
      Object.keys(this.dataForm).forEach(item => {
        obj[item] = rule;
        return obj;
      });
      // 辅助轮
      const numValidator = (value) => {
        const pattern = /^[0-4]$/g;
        console.log('num:', value);
        if (!value) {
          return true;
        } else if (pattern.test(value) && value >= 0 && value <= 4) {
          return true;
        } else {
          return false;
        }
      };
      obj.num = [
        { validator: numValidator, message: '请输入正确格式的数值，0-4的整数', trigger: 'onBlur' }
      ];
      // 其他费用
      const otherValidator = (value) => {
        if (!value) {
          return !this.dataForm.cost7;
        } else {
          return true;
        }
      };
      obj.cost8 = [
        { validator: otherValidator, message: '请输入其他费用说明', trigger: 'onBlur' }
      ];
      return obj;
    }
  },
  methods: {
    open(data) {
      data && (this.data = { ...this.data, ...data });
      console.log('this.data:', this.data);
      this.show = true;
      this.queryOrderFeeDetail();
    },
    close() {
      this.show = false;
    },
    async confirm() {
      const result = await this.validate();
      console.log(result);
      if (!result) {
        return;
      }
      await this.saveOrderFeeDetail();
    },
    cancel() {
      this.data.cancelCallback && this.data.cancelCallback.apply(this);
      this.close();
    },
    async validate() {
      if (!this.$refs.form) {
        return true;
      }
      try {
        await this.$refs.form.validate();
        return true;
      } catch (err) {
        console.log(err);
        Toast({
          message: err[0].message,
          position: 'bottom'
        });
        return false;
      }
    },
    async queryOrderFeeDetail() {
      try {
        const data = await queryOrderFeeDetail(this.data.extraParam);
        if (data) {
          const feeInfo = data.feeInfo || [];
          console.log(feeInfo);
          feeInfo.forEach(item => {
            this.dataForm[`cost${item.code}`] = item.desc;
            if (item.code === '5') {
              this.dataForm.num = item.name.split('-')[1];
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrderFeeDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '保存中...',
          forbidClick: true
        });
      }
      try {
        const {
          cost1,
          cost2,
          cost3,
          cost4,
          cost5,
          cost6,
          cost7,
          cost8,
          num
        } = this.dataForm;
        const feeInfo = [];
        const valueList = [
          cost1,
          cost2,
          cost3,
          cost4,
          cost5,
          cost6,
          cost7,
          cost8
        ];
        valueList.forEach((item, index) => {
          if (item) {
            const obj = {
              code: `${index + 1}`,
              name: this.keyList[index],
              desc: item
            };
            if (index === 4 && num) {
              obj.name = `${this.keyList[index]}-${num}`;
            }
            feeInfo.push(obj);
          }
        });

        await saveOrderFeeDetail({
          ...this.data.extraParam,
          feeInfo
        });
        this.$toast('保存成功');

        this.data.confirmCallback && this.data.confirmCallback.call(this);
        this.close();
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cost-entry-box ::v-deep{
  .van-action-sheet__header{
    padding: 14px 16px 13px;

    text-align: center;

    color: #383838;
    border-bottom: 1px solid rgba(230,230,230,1);

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
  }
  .form-box{
    .form-item{
      padding: 0 16px;
      .textarea-box {
        padding: 8px 10px 7px;

        border-radius: 4px;

        &.van-field--min-height .van-field__control{
          min-height: 42px;
        }

        &.input-box {
          height: 36px;
        }
      }
      .form-item-box {
        padding: 10px 0;

        border-bottom: 1px solid rgba(230,230,230,1);
      }
    }
    .form-label{
      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }
    .form-tips{
      color: #999999;

      font-family: PingFangSC-Regular;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
    }
  }
  .btn-box{
    padding: 10px 16px;
    .van-button{
      height: 40px;
      padding: 9px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--default{
        color: #646464;
        border: 1px solid rgba(200,200,200,1);
        background: #FFFFFF;
      }

      &.van-button--info{
        color: #FFFFFF;
        border: 1px solid #3399FF;
        background: #3399FF;
      }
    }
  }
}
</style>
